export interface ShopToClubBannerABTestState {
    categoryId: string;
    imgSrc: string;
    desktopImg: string;
    linkUrl: string;
    categories: string;
}

export const ShopToClubBannerABTestInitialState: ShopToClubBannerABTestState = {
    categoryId: '',
    imgSrc: '',
    desktopImg: '',
    linkUrl: '',
    categories: '',
};

export default {};
